import React, { RefObject } from 'react'

const useInputValidate = () => {
    const validateField = (fieldRef: RefObject<HTMLSelectElement> | RefObject<HTMLInputElement> | RefObject<HTMLTextAreaElement>) => {
        if(fieldRef.current?.value)
        {
            fieldRef.current.classList.remove('error')
            return true
        }
        else
        {
            fieldRef.current?.classList.add('error')
            return false
        }
    }
    return {validateField}
}

export default useInputValidate